module.exports = __webpack_public_path__ + "static/media/PZ_1_etapa.6da272d0.jpg";